<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form
      :model="queryParams"
      label-position="right"
      label-width="70px"
      class="demo-form-inline"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <!-- 物资类别 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资类别">
            <el-input
              v-model="queryParams.categoryName"
              placeholder="请输入物资类别"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 物资名称 -->
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="物资名称">
            <el-input
              v-model="queryParams.assetName"
              placeholder="请输入物资名称"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>

        <!-- 报废时间 -->
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="报废时间">
            <el-date-picker
              v-model="queryParams.useDateRange"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              clearable
              style="width: 100%"
              @change="handleDateChange"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 按钮区域 -->
      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button @click="handleExport">导出</el-button>
      </div>
    </el-form>

    <!-- 日常消耗表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <el-table-column prop="categoryName" label="物资类别" />
      <el-table-column prop="assetName" label="物资名称" />
      <el-table-column prop="count" label="数量" />
      <el-table-column prop="remark" label="备注" />
      <el-table-column label="附件" width="200">
        <template slot-scope="scope">
          <div
            v-if="
              Array.isArray(scope.row.attachments) &&
              scope.row.attachments.length
            "
          >
            <ImagePreviewList :images="scope.row.attachments" />
          </div>
          <div v-else class="no-image-text">-- 暂无图片 --</div>
        </template>
      </el-table-column>

      <el-table-column prop="approverName" label="审批人" />
      <el-table-column prop="state" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag
            :type="
              [1, 14].includes(scope.row.state)
                ? 'success'
                : [0, 13].includes(scope.row.state)
                ? 'warning'
                : 'danger'
            "
          >
            {{ STAMP_STATUS_MAP[scope.row.state] }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rejectReason" label="拒绝理由" />
      <el-table-column prop="createTime" label="报废时间" />
    </el-table>

    <!-- 分页 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
import { dailyAssetsScrap, dailyAssetsScrapExport } from "@/api/material";
import ImagePreviewList from "@/components/ImagePreviewList/index";

import PaginationBar from "@/components/PaginationBar";
import { STAMP_STATUS } from "@/utils/const.js";
import { listToMap, downloadFile } from "@/utils/util";

const STAMP_STATUS_MAP = listToMap(STAMP_STATUS);

export default {
  name: "ScrapRecord",
  components: { PaginationBar, ImagePreviewList },
  data() {
    return {
      STAMP_STATUS_MAP,
      activeTab: "consumables",
      queryParams: {
        categoryName: "",
        assetName: "",
        useDateRange: [],
      },
      startCreateTime: "",
      endCreateTime: "",
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.startCreateTime = dateRange[0]; // "2025-05-30 00:00:00"
        this.endCreateTime = dateRange[1]; // "2025-06-02 23:59:59"
      } else {
        this.startCreateTime = "";
        this.endCreateTime = "";
      }
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      dailyAssetsScrap({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        categoryName: this.queryParams.categoryName,
        assetName: this.queryParams.assetName,
        startCreateTime: this.startCreateTime,
        endCreateTime: this.endCreateTime,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        categoryName: "",
        assetName: "",
        useDateRange: [],
      };
      this.startCreateTime = "";
      this.endCreateTime = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    handleTabChange() {
      this.resetQuery();
    },
    handleExport() {
      dailyAssetsScrapExport({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        categoryName: this.queryParams.categoryName,
        assetName: this.queryParams.assetName,
        startCreateTime: this.startCreateTime,
        endCreateTime: this.endCreateTime,
      }).then((res) => {
        downloadFile(
          res.data,
          "日常消耗报废记录数据.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style scoped>
.app-container {
}
.el-card {
  margin-bottom: 20px;
}
</style>
